import React from 'react';
import { COLORS, FONTS, cardStyle, primaryButtonStyle } from '../signup/signupStyles';

export const ValueConfirmation = ({ firstName, condition, onCompleteProfile, onDone }) => (
  <div style={{
    minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
    fontFamily: FONTS.system
  }}>
    <style>{`
      @keyframes fadeUp {
        from { opacity: 0; transform: translateY(12px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @media (max-width: 480px) {
        .vf-confirm-card { padding: 32px 24px !important; }
      }
    `}</style>

    <div className="vf-confirm-card" style={{ ...cardStyle, textAlign: 'center', animation: 'fadeUp 0.5s ease-out' }}>
      {/* Checkmark */}
      <div style={{
        width: '64px', height: '64px', borderRadius: '50%',
        backgroundColor: COLORS.text,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 20px'
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="white" strokeWidth="3" strokeLinecap="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>

      <h1 style={{
        fontFamily: FONTS.serif, fontSize: 'clamp(22px, 4vw, 28px)',
        fontWeight: '700', color: COLORS.text, margin: '0 0 12px'
      }}>
        You're in, {firstName}.
      </h1>

      <p style={{
        fontSize: '15px', color: COLORS.muted, lineHeight: 1.6,
        margin: '0 0 12px'
      }}>
        Your answer is live in the {condition} community. We'll notify you when others respond.
      </p>

      <p style={{
        fontSize: '15px', color: COLORS.muted, lineHeight: 1.6,
        margin: '0 0 32px'
      }}>
        Complete your profile to get matched with paid research studies — patients earn $75–$500 per study.
      </p>

      <button onClick={onCompleteProfile}
        style={{ ...primaryButtonStyle, width: '100%', padding: '16px 24px', marginBottom: '12px' }}
        onMouseEnter={(e) => { e.target.style.backgroundColor = '#3a3a39'; }}
        onMouseLeave={(e) => { e.target.style.backgroundColor = COLORS.text; }}
      >
        Complete Profile & See Studies
      </button>

      <button onClick={onDone} style={{
        width: '100%', padding: '10px 24px', fontSize: '14px',
        fontWeight: '500', color: COLORS.muted, backgroundColor: 'transparent',
        border: 'none', cursor: 'pointer'
      }}>
        I'll do this later
      </button>
    </div>
  </div>
);
